<template>
  <div class="loginContainer">
    <!-- 头部盒子 -->
    <div class="header">
      <!-- 标题区域 -->
      <div class="lnner-header">
        <el-form
          @keyup.enter.native="toLogin"
          :model="loginForm"
          ref="loginRef"
          :rules="loginRules"
          class="loginContainer-form"
        >
          <el-form-item>
            <h4>道可道也教学与教务服务平台</h4>
            <p style="font-size: 14px; color: #808080">
              DaoKeDaoYe Teaching and Academic Affairs Service Platform
            </p>
          </el-form-item>
          <el-form-item prop="account">
            <el-input
              @keyup.tab.native="focusNext('password')"
              :disabled="disabled"
              prefix-icon="el-icon-user"
              v-model="loginForm.account"
              placeholder="请输入用户名！"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              ref="password"
              type="password"
              :disabled="disabled"
              prefix-icon="el-icon-key"
              v-model="loginForm.password"
              placeholder="请输入密码！"
              @keyup.tab.native="focusNext('captcha')"
            ></el-input>
          </el-form-item>
          <div class="loginContainer-form-caption">
            <el-form-item prop="captcha">
              <el-input
                prefix-icon="el-icon-news"
                ref="captcha"
                :disabled="disabled"
                v-model="loginForm.captcha"
                type="text"
                placeholder="请输入验证码"
                name="captcha"
              />
            </el-form-item>
            <img
              @click="VerificationAxios"
              :src="img"
              alt="点击更换验证码"
              class="loginImage"
            />
          </div>
          <el-form-item>
            <div class="loginContainer-form-actions">
              <el-button
                type="primary"
                class="loginContainer-form-newVersion"
                @click="toNewVersion"
              >
                前往新版教务系统
                <i class="el-icon-top-right"></i>
              </el-button>
              <el-button
                type="primary"
                :disabled="disabled"
                class="loginContainer-form-button"
                @click="toLogin"
                >登录</el-button
              >
            </div>
          </el-form-item>
          <div style="font-size: 14px; color: #808080">
            <p>道可道也研发中心提供支持</p>
            <p style="display: flex; align-items: center">
              <img
                style="width: 30px; height: 30px"
                src="https://hbyoss.houbaoyan.cn/tms/static/safe.png"
                alt=""
              />
              道可道也教学与教务服务平台已接入自研行为分析安全引擎
            </p>
            <p
              style="
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <img
                style="width: 29px; height: 29px"
                src="https://hbyoss.houbaoyan.cn/static/img/tongyiqianwen.png"
                alt=""
              />
              <img
                style="margin: -40px 0; width: 130px"
                src="https://hbyoss.houbaoyan.cn/static/img/deepseek.png"
                alt=""
              />
            </p>
            <p>道可道也研发中心 AI 强力驱动</p>
          </div>
        </el-form>
        <div style="padding-top: 40px; color: white"></div>
      </div>
      <!-- 波浪区域 -->
      <!-- <div>
        svg形状
        <svg class="waves" viewBox="0 24 150 28" preserveAspectRatio="none" shape-rendering="auto">
          形状容器
          <defs>
            <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
          </defs>
          组合形状
          <g class="parallax">
            <use xlink:href="#gentle-wave" x="48" y="0" fill="rgba(255,255,255,0.7" />
            <use xlink:href="#gentle-wave" x="48" y="3" fill="rgba(255,255,255,0.5)" />
            <use xlink:href="#gentle-wave" x="48" y="5" fill="rgba(255,255,255,0.3)" />
            <use xlink:href="#gentle-wave" x="48" y="7" fill="#fff" />
          </g>
        </svg>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { getCaption, login, validateApi } from "@/config/http/login.js";
import { EAS_LOGIN_URL } from "@/utils/newSystem";
export default {
  name: "LoginViews",
  data() {
    return {
      loginForm: {
        account: "",
        password: "",
        captcha: "",
      },
      // 验证码
      img: "",
      disabled: false,
      captchaKey: "",
      loginRules: {
        account: [
          { required: true, message: "用户名为必填项！", trigger: "blur" },
        ],
        password: [
          { required: true, message: "密码为必填项！", trigger: "blur" },
        ],
        captcha: [
          { required: true, message: "验证码为必填项！", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.validate();
  },
  created() {
    this.VerificationAxios();
  },
  methods: {
    // validateResult  // 整数，对应风险结果
    // reason  // 字符串，表示风险信息
    // data  // 字符串，用来与validateResult配合使用
    // 以validateResult进行不同操作：
    // 4001  环境存在异常，客户端的本地时间与服务器事件存在较大差值，不可执行登录 disable。 弹出提示：您的环境存在异常（response.data.reason）
    // 9000  风控服务异常，按存在风险处理，不可执行登录 disable。 弹出提示：您的环境存在异常（response.data.reason）
    // 1001、1002 存在环境区域风险，可能是单点IP、或者区域IP封禁，不可执行登录 disable。 弹出提示：您的环境存在异常（response.data.reason）
    // 1003  存在环境区域风险，与1002不同的是，需要浏览器【直接跳转】到 response.data.data 表示的URL中。
    // 1004-1999 存在环境区域风险,处理方式同 1001
    // 2000-2999 存在管控风险，如果当前被检测到使用其他工具异常，不可执行登录 disable。弹出提示：您的环境存在异常（response.data.reason）
    validate() {
      validateApi({
        time: new Date().getTime(),
      })
        .then((res) => {
          let { reason, validateResult } = res.data.data;
          if (validateResult === 4001) {
            this.disable(reason);
            return;
          }
          if (validateResult === 9000) {
            this.disable(reason);
            return;
          }
          if (validateResult === 1001 || validateResult === 1002) {
            this.disable(reason);
            return;
          }
          if (validateResult === 1003) {
            window.location.href = res.data.data.data;
            return;
          }
          if (validateResult >= 1004 && validateResult <= 1999) {
            this.disable(reason);
            return;
          }
          if (validateResult >= 2000 && validateResult <= 2999) {
            this.disable(reason);
            return;
          }
        })
        .catch((err) => {
          this.disabled = true;
        });
    },
    disable(reason) {
      this.disabled = true;
      this.$message.error(`您的环境存在异常（${reason}）`);
    },
    focusNext(nextRef) {
      console.log(nextRef, "nextRef");
      // this.$refs[nextRef].focus()
    },
    toNewVersion() {
      // 开发环境跳内网 9527，线上跳 eas.houbaoyan.cn（见 utils/newSystem）
      const base = `${EAS_LOGIN_URL}?redirect=/workplace`;

      // 登录是异步的，回调里再 window.open 会被浏览器当弹窗拦截，
      // 所以先同步开一个空标签页，拿到结果后再改它的地址
      const target = window.open("about:blank", "_blank");

      const jump = (token) => {
        const url = token ? `${base}&token=${encodeURIComponent(token)}` : base;

        if (target && !target.closed) {
          target.location.href = url;
        } else {
          window.location.href = url;
        }
      };

      const { account, password, captcha } = this.loginForm;

      // 没填全就不试登录，直接不带 token 跳
      if (!account || !password || !captcha) {
        jump();
        return;
      }

      this.loginForm.captchaKey = this.captchaKey;

      login(this.loginForm)
        .then((res) => jump(res.data.data.token))
        .catch(() => jump());
    },
    // vuex
    ...mapMutations("user", {
      setToken: "setToken",
      setPression: "setPression",
    }),
    // 验证码
    VerificationAxios() {
      const _this = this;
      console.log(_this, "this");
      getCaption().then((res) => {
        _this.img = res.data.data.image;
        _this.captchaKey = res.data.data.captchaKey;
      });
    },
    toLogin() {
      this.$refs.loginRef.validate(async (valid) => {
        if (valid) {
          this.loginForm.captchaKey = this.captchaKey;
          login(this.loginForm)
            .then((res) => {
              this.setToken(res.data.data.token);
              this.$notify({
                type: "success",
                message: "登录成功！",
              });
              this.$router.replace({
                path: "/workplace",
              });
            })
            .catch((err) => {
              if (err.data.msg === "密码错误" && err.data.status === 1100) {
                this.$alert(
                  "你的密码错误，如果屡次尝试登录均密码错误，可能是因为你触发了风控管制，导致你被强踢下线并刷新了密码，请咨询你的主管获取新密码。注意：请在明天00:00再继续使用，否则风控系统仍会将你被踢下线并刷新密码。",
                  "提示",
                  {
                    confirmButtonText: "确定",
                    callback: (action) => {},
                  }
                );
              }
            });
        } else {
          this.$message({ type: "error", message: "账户和密码为必填项！" });
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.loginContainer {
  background: url("https://hbyoss.houbaoyan.cn/tms/static/login_background.png")
    no-repeat;
  background-size: 100vw 100vh;
}
.header {
  position: relative;
  // text-align: center;
  /* 背景渐变 */
  // background: linear-gradient(60deg, rgba(84, 58, 183, 1) 0%, rgba(0, 172, 193, 1) 100%);
  // background-color: #002033;
  // color: wheat;
  .lnner-header {
    // height: 65vh;
    height: 100vh;
    width: 93%;
    /* flex */
    /* 垂直居中 */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    // background-color: white;
  }
  .waves {
    position: relative;
    width: 100%;
    height: 15vh;
    margin-bottom: -7px;
    /* 最小值 */
    min-height: 100px;
    /* 最大值 */
    max-height: 150px;
    .parallax > use {
      animation: move-forever 25s cubic-bezier(0.55, 0.5, 0.45, 0.5) infinite;
    }
    /* 选择的一个use */
    .parallax > use:nth-child(1) {
      /* 延迟 2s 执行 */
      animation-delay: -2s;
      /* 7s 内 执行完毕 */
      animation-duration: 7s;
    }
    .parallax > use:nth-child(2) {
      animation-delay: -3s;
      animation-duration: 10s;
    }
    .parallax > use:nth-child(3) {
      animation-delay: -4s;
      animation-duration: 13s;
    }
    .parallax > use:nth-child(4) {
      animation-delay: -5s;
      animation-duration: 20s;
    }
  }
}
/* 动画 */
@keyframes move-forever {
  0% {
    transform: translate3d(-90px, 0, 0);
  }
  100% {
    transform: translate3d(85px, 0, 0);
  }
}
/* 当屏幕小于 768px 执行 */
@media (max-width: 768px) {
  .waves {
    height: 40px;
    min-height: 40px;
  }
  h1 {
    font-size: 24px;
  }
}
.loginContainer {
  // position: fixed;
  // top: 0;
  // right: 0;
  // bottom: 0;
  // left: 0;
  // display: flex;
  // align-items: center;
  // justify-content: center;
  // background-color: #303133;
  // background-size: cover;
  &-form {
    width: 490px;
    text-align: center;
    // height: 400px;
    padding: 40px;
    padding-right: 30px;
    box-sizing: border-box;
    background-color: white;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.19);
    border-radius: 11px;
    h4 {
      font-size: 24px;
      // color: #fff;
      color: black;
    }
    &-caption {
      display: flex;
      justify-content: space-between;
      img {
        height: 40px;
        margin-left: 6px;
      }
    }
    &-actions {
      display: flex;
      align-items: center;
    }
    &-button {
      flex: 1;
      width: auto;
      margin-left: 10px;
    }
    &-newVersion {
      flex: none;
      width: 50%;
      margin-left: 0;
      background-color: #67c23a;
      border-color: #67c23a;
      &:hover,
      &:focus {
        background-color: #85ce61;
        border-color: #85ce61;
      }
    }
  }
}
</style>
